/**
 * @generated SignedSource<<ee332b7999c89956173cb8ce705fca03>>
 * @relayHash 4a05cab03b3b1d8516a9971fd67e919c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f96fb58932fe3a1bb9ee158860a779e80ed0fc9c3cdc2070e5715bd09111c6fa

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type setIsTrialSprintBoardModalDismissedQuery$variables = {
  projectAri: string;
};
export type setIsTrialSprintBoardModalDismissedQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly created: AGG$DateTime | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly projectStyle: JiraProjectStyle | null | undefined;
      readonly projectType: JiraProjectType | null | undefined;
      readonly status: JiraProjectStatus | null | undefined;
      readonly tmpBoardId: AGG$Long | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type setIsTrialSprintBoardModalDismissedQuery = {
  response: setIsTrialSprintBoardModalDismissedQuery$data;
  variables: setIsTrialSprintBoardModalDismissedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
          }
        ],
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jiraProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "created"
          },
          {
            "kind": "ScalarField",
            "name": "tmpBoardId"
          },
          {
            "kind": "ScalarField",
            "name": "projectStyle"
          },
          {
            "kind": "ScalarField",
            "name": "projectType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "setIsTrialSprintBoardModalDismissedQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setIsTrialSprintBoardModalDismissedQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f96fb58932fe3a1bb9ee158860a779e80ed0fc9c3cdc2070e5715bd09111c6fa",
    "metadata": {},
    "name": "setIsTrialSprintBoardModalDismissedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8c1a517e7c168f46d9c713e614521ab6";

export default node;
